export const SET_POSITION = 'SET_POSITION'
export const SET_WORKING = 'SET_WORKING'
export const SET_SUCCESS = 'SET_SUCCESS'
export const CLEAR_ERROR = 'CLEAR_ERROR'
